import React, { FC, useEffect } from 'react';
import { FieldRenderProps } from 'react-final-form';
import { WysiwygEditor } from 'src/modules/shared/components';

import { scrollToViewById } from 'src/modules/shared/helpers/scroll';
type WysiwygEditorFieldProps = {
  props: FieldRenderProps<string, HTMLElement, string>;
  required: boolean;
};

const WysiwygEditorField: FC<WysiwygEditorFieldProps> = ({ props, required }) => {
  const { meta, input } = props;
  const showError = input.value === '' && meta.submitFailed && required;

  useEffect(() => {
    if (!showError) return;
    scrollToViewById(input.name, { block: 'end' });
  }, [input.name, showError]);

  return (
    <>
      <WysiwygEditor
        id={input.name}
        className={!showError ? '' : 'form-error'}
        type="normal"
        value={input.value}
        handleBlur={input.onChange}
      />
      {showError && (
        <p className="MuiFormHelperText-root Mui-error" id="title-helper-text">
          Dit veld is verplicht.
        </p>
      )}
    </>
  );
};

export default WysiwygEditorField;
